// Operator-visible validation copy for the shared inventory field rules (BL-889).
//
// This is a LEAF module — it imports nothing. That is the whole point. The two
// modules that need these strings sit on the same import chain:
//
//   ./inventory  ──imports RequiredTitleSchema──▶  ./item-form
//
// so neither can own the constants without the other forming a cycle back to
// it, and a cycle would evaluate these `const`s in the temporal dead zone —
// silently yielding `undefined` validation messages at schema-construction
// time. Hoisting them to a leaf both sides import removes the direction
// problem entirely.
//
// `./inventory` re-exports these so `@auctogon/core-admin/schemas/inventory`
// remains the one canonical import path for consumers. `./item-form` imports
// them WITHOUT re-exporting, because the `./schemas` barrel `export *`s both
// files and two modules exporting the same name would make it ambiguous.
//
// No trailing periods — these match the copy already rendered inline under the
// fields in `ItemForm`, and the admin lot routes' period-terminated twins were
// retired in BL-889 as the drift AC 2 forbids.

/** VIN is a fixed-width NHTSA identifier; `chk_inventory_vin_length` enforces it in the DB. */
export const INVENTORY_VIN_MESSAGE = 'VIN must be exactly 17 characters';

/** Mirrors the `chk_inventory_year_range` DB constraint. */
export const INVENTORY_YEAR_MESSAGE = 'Year must be between 1900 and 2100';

/** A meter reading can be 0 but never negative. */
export const INVENTORY_HOURS_MILEAGE_MESSAGE = 'Hours/mileage cannot be negative';
